import React, { useMemo } from 'react';
import { useAppContext } from 'services/context';
import { AnimatePresence, motion } from 'framer-motion';
import classNames from 'classnames';

import Icon from 'components/Icon';
import './style.css';

const NotificationManager = ({ notifications }) => {
	return (
		<div className="NotificationManager">
			<AnimatePresence>
				{notifications &&
					notifications?.map(notif => <Notification key={notif.id} message={notif.message} duration={notif.duration} type={notif.type} />)}
			</AnimatePresence>
		</div>
	);
};

export default NotificationManager;

export const Notification = ({ message, type = 'success' }) => {
	const notificationClassName = classNames('Notification', {
		error: type === 'error',
		success: type === 'success',
	});

	// Framer Motion animation variants
	const variants = {
		hidden: { opacity: 0, x: 100 }, // Start off-screen to the right
		visible: {
			opacity: 1,
			x: 0, // Slide into position
			transition: {
				type: 'spring', // Spring animation for smoothness
				stiffness: 300,
				damping: 25,
			},
		},
		exit: {
			opacity: 0,
			x: 100, // Slide out to the right
			transition: { duration: 0.3 },
		},
	};

	const releventIcon = useMemo(() => {
		switch (type) {
			case 'success':
				return <Icon icon="successVicon" color="white" />;
			case 'error':
				return <Icon icon="closeIcon" color="white" />;
			default:
				break;
		}
	}, [type]);

	return (
		<motion.div className={notificationClassName} initial="hidden" animate="visible" exit="exit" variants={variants}>
			<div className="icon">{releventIcon}</div>
			{message}
		</motion.div>
	);
};
